import { render, staticRenderFns } from "./IndexSystem.vue?vue&type=template&id=18f3dc86&scoped=true"
import script from "./IndexSystem.vue?vue&type=script&lang=js"
export * from "./IndexSystem.vue?vue&type=script&lang=js"
import style0 from "./IndexSystem.vue?vue&type=style&index=0&id=18f3dc86&prod&scoped=true&lang=css"
import style1 from "./IndexSystem.vue?vue&type=style&index=1&id=18f3dc86&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f3dc86",
  null
  
)

export default component.exports